import React from 'react';

import { ConfirmDialog } from 'features/core/confirm-dialog';

import { UpdateNotifier } from './update-notifier';
import { MccLookup } from '../tools/mcc-lookup';
import { Loader } from '../top-loader/loader';

/**
 * Holds all components that generate popups and other overlays throughout the app.
 */
export class AppOverlays extends React.Component {
    public render(): React.ReactNode {
        return (
            <React.Fragment>
                <Loader />
                <UpdateNotifier />
                <MccLookup />
                <ConfirmDialog />
            </React.Fragment>
        );
    }
}
